import api, { unwrap } from './client';

// CHR refonte 2026-05-27 — vue par année (données HR effectives + saisies CHR par personne par année).

export const getChrYearly = (tenantId, year) =>
  unwrap(api.get(`/chr/${tenantId}/${year}`));

export const upsertChrYearlyInput = (tenantId, year, personId, payload) =>
  unwrap(api.patch(`/chr/${tenantId}/${year}/${personId}`, payload));

export const copyChrYearlyYear = (tenantId, fromYear, toYear, overwrite = false) =>
  unwrap(api.post(`/chr/${tenantId}/copy-year`, {
    from_year: fromYear, to_year: toYear, overwrite,
  }));
